import {
    SIGNUP_SUCCESS,
    SIGNUP_FAILURE,
    SET_USER_DETAILS,
    LOGOUT
} from './action';
const initialState = {
    signUpSuccess: {},
    signUpFailure:{},
    userDetails: {}
}

const signUpReducer = (state=initialState, action) => {
    switch(action.type) {
        case SIGNUP_SUCCESS:
            return  state = {
                ...state,
                signUpSuccess: action.data
            }
        case SIGNUP_FAILURE:
            return  state = {
                ...state,
                signUpFailure: action.data
            }
        case SET_USER_DETAILS:
            return state = {
                ...state,
                userDetails: action.data
            }
        case LOGOUT:
            return state = {
                ...initialState
            }
        default: return state
    }
}
export default signUpReducer;
